import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DropZone, TextStyle, Button, Icon } from '@shopify/polaris';
import { DeleteMajorMonotone } from '@shopify/polaris-icons';
import { getFileURL } from '@utils';

const propTypes = {
  imageFile: PropTypes.shape({
    url: PropTypes.string, // For existing images
    type: PropTypes.string,
    name: PropTypes.string,
  }),
  onDelete: PropTypes.func,
  
  onDrop: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
}

const defaultProps = {

}

const ImageDropZone = (props) => {
  const [openFileDialog, setOpenFileDialog] = useState(false);

  const { imageFile, onDelete, label, ...dropZoneProps } = props;

  const imagePreview = (
    <div className="flex justifyCenter alignItemsCenter">
      <img style={{ maxWidth: "100%" }} src={ getFileURL(props.imageFile || {}) } />
    </div>
  )

  // const toggleFileDialog = () => setOpenFileDialog(!openFileDialog);
  const openFileDialogF = () => setOpenFileDialog(true);
  const closeFileDialog = () => setOpenFileDialog(false);

  const uploadPlaceholder = (
    <div className="p20" >
      <DropZone.FileUpload actionTitle="Añadir imagen" actionHint="o arrastra la imagen" />
    </div>
  )

  return (
    <div>
      <div className="flex alignItemsCenter mb5">
        <div className="mr10">
          <TextStyle>{ label }</TextStyle>
        </div>
        { onDelete &&
          <Button onClick={ onDelete } plain >
            <Icon source={DeleteMajorMonotone} />
          </Button>
        }
      </div>
      {/* allowMultiple because if not a bug would not allow to reupload file after removal for some reason */}
      <DropZone
        allowMultiple={ true }
        onClick={ openFileDialogF }
        type="image"
        openFileDialog={ openFileDialog }
        onFileDialogClose={ closeFileDialog }
        { ...dropZoneProps }
      >
        { props.imageFile ? imagePreview : uploadPlaceholder }
      </DropZone>
    </div>
  )
};

ImageDropZone.propTypes = propTypes;
ImageDropZone.defaultProps = defaultProps;

export default ImageDropZone;